module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@2x.93b87deb.png";